import { Environment } from '@lib/classes';

export const environment: Environment = {
  production: true,
  signInRoute: 'auth/login',
  siteUrl: '',
  apiBasePath: 'https://api-del.xplore.cy',
  websocketServerPath: 'https://api-del.xplore.cy',
  stripeKey:
    'pk_test_51RTjZsPFQN5RYaHHTNxZnNJrOOkD6NWAD0KRbeXcmV1unIbOCQqMqaDBtdpQcwbTEF2YB8GIUAIWWuHgwaXQnq2P00oeNOeNia',
  posthogKey: '',
  posthogHost: 'https://eu.i.posthog.com',
};
